import React, { useContext, FC } from "react";
import { LocalizationContext } from "../../../../../../../../locales/Translation";
import { PUBLIC_URL } from "../../../../../../../App/configs/Constants";
import DropdownWithCheckboxMenuWithTotal from "../../../../../../../../components/DropdownWithCheckboxMenuWithTotal";
import { CheckboxOption, FilterProps } from "../../types";

const STATUS_OPTIONS: CheckboxOption[] = [
  { id: 0, name: "Unpublished" },
  { id: 1, name: "Published" },
];

const FilterStatus: FC<FilterProps> = ({ onChangeFilter, filters }) => {
  const { translations } = useContext(LocalizationContext);

  const filterIcon = (
    <img alt="Filter" src={`${PUBLIC_URL}/assets/icons/icon-filter.svg`} />
  );

  return (
    <div className="dropdown-filter">
      <DropdownWithCheckboxMenuWithTotal
        values={filters}
        onChange={onChangeFilter}
        listCheckBox={STATUS_OPTIONS}
        label={translations.filters}
        icon={filterIcon}
      />
    </div>
  );
};

export default FilterStatus;
